import React from 'react';


function ClientRightTem(props){

    return (
       
        <>
         
<div  className="card" style={{width: "18rem;", marginBottom: "30px"}}>


<div className="card-body">
    <div style={{display: "flex"}}>
    <p className="card-title"><strong><span class="material-symbols-rounded writing">device_thermostat</span>Temparature</strong></p>   <p className='m-auto Font-primary'></p>
      
{/* 
    <span className='info leftAling'>
  <div class="dropdown">
                <span className="info" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{marginBottom:"20px"}}>
                  <span class="material-symbols-rounded">more_horiz</span>
                </span>
                <div class="dropdown-menu" aria-labelledby="" style={{marginTop:"5px", marginLeft:"20px"}}>
                <a class="dropdown-item" href="#">Last 24 Hours</a>
    <a class="dropdown-item" href="#">Last Week</a>
    <a class="dropdown-item" href="#">Last 30 Days</a>
  </div></div>

</span>
*/}
      
     </div>

   
<div className='d-flex'>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Min: </strong></span>

   <p className='Font-primary currentCharging'>{props.min} ℃</p> 
    
    </div>

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Max: </strong></span>

   <p className='Font-primary currentCharging'>{props.max} ℃</p> 
    
    </div>
  </div>
    <hr />
    <p style={{fontSize:"30px"}}><span class="material-symbols-rounded">device_thermostat</span>
    <strong>{props.temp} ℃</strong>
    </p>

   
   
  </div>

</div>
        </>
    )
}

export default ClientRightTem;